export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_NEXT_API_URL || 'http://localhost:3001',
  LAMBDA_URL:
    process.env.NEXT_PUBLIC_LAMBDA_URL ||
    'https://oddx6adyeuiepaooaivm2bjaee0jhwhx.lambda-url.us-east-1.on.aws',
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      REFRESH_TOKEN: '/auth/refresh-token',
      VERIFY_EMAIL: '/auth/verify-email',
      RESET_PASSWORD: '/auth/reset-password',
      REQUEST_RESET: '/auth/request-reset',
    },
    USERS: {
      BASE: '/users',
      REGISTER: '/users',
      UPDATE: (userId: string) => `/users/${userId}`,
    },
    PROFILE: {
      BASE: '/profiles',
      UPDATE: (userId: string) => `/profiles/${userId}`,
      FILTERS: '/profiles/filters',
      LAWYERS: '/profiles/lawyers',
    },
    FORM_TEMPLATE: {
      BASE: '/form-template',
      UPDATE: (formId: string) => `/form-template/${formId}`,
      IDENTIFY: '/form-template/identify',
      SIGNED_URL: '/form-template/signed-url',
    },
    FILLED_FORM: {
      BASE: '/filled-forms',
      CREATE_WITH_CONTENT: '/filled-forms/create-with-content',
    },
    FORMAL_NOTICE: {
      BY_USER: (userId: string) => `/generated-documents/user/${userId}`,
      BY_ID: (documentId: string) => `/generated-documents/${documentId}`,
      GENERATE_FORMAL_NOTICE: '/generated-documents/generate-formal-notice',
      SAVE_FORMAL_NOTICE: (formalNoticeId: string) =>
        `/generated-documents/update-status/${formalNoticeId}`,
      DELETE: (formalNoticeId: string) =>
        `/generated-documents/${formalNoticeId}`,
      SIGNED_URL: (documentId: string) =>
        `/generated-documents/${documentId}/signed-url`,
    },
    FORM: {
      CREATE: '/formAnswer',
      GET: '/formAnswer',
      GET_BY_ID: (id: string) => `/formAnswer/${id}`,
      UPDATE: (id: string) => `/formAnswer/${id}`,
    },
    CASELAW: {
      BASE: '/caselaw',
      SEARCH: {
        SUBMIT: '/caselaw/search',
        DELETE: (id: string) => `/caselaw/search/${id}/delete`,
      },
      SITUATION: {
        CREATE: '/caselaw/create-situation',
        GET_ALL: '/caselaw/situations',
        GET_BY_ID: (id: string) => `/caselaw/situation/${id}`,
        DELETE: (id: string) => `/caselaw/situation/${id}/delete`,
        ADD_CASE: (situationId: string, caseId: string) =>
          `/caselaw/situation/${situationId}/case/${caseId}`,
        REMOVE_CASE: (situationId: string, caseId: string) =>
          `/caselaw/situation/${situationId}/case/${caseId}/remove`,
        GET_CASES: (situationId: string) =>
          `/caselaw/situation/${situationId}/cases`,
      },
    },
    ADVICE: {
      BASE: '/advices',
      LIST: '/advices/list',
      ITEMS: (id: string) => `/advices/${id}/items`,
      ITEM_STATUS: (itemId: string) => `/advices/items/${itemId}/status`,
      FORM_ANSWERS: (id: string) => `/advices/${id}/formAnswers`,
      TITLE: (id: string) => `/advices/${id}/title`,
      GET_ADVICE: (id: string) => `/advices/${id}`,
      CREATE_ADVICE: (conversationId: string) =>
        `/advices/${conversationId}/create-advice`,
      STORE_ADVICE: (adviceId: string) => `/advices/${adviceId}/store-advice`,
      DELETE: (id: string) => `/advices/${id}`,
      FEEDBACK: '/flaggedResponse',
      CHAT: '/chat',
      PROMPT: '/prompt',
      HEALTH: '/health',
      HISTORY: (id: string) => `/advices/${id}/history`,
    },
    ADVICE_SOURCE: {
      CLICK: (sourceId: string) => `/advices/source/${sourceId}/click`,
    },
    ADMIN: {
      BASE: '/admin',
      OVERVIEW: '/admin/overview',
      USERS: '/admin/users',
      USER: (userId: string) => `/admin/users/${userId}`,
      CHAT_HISTORY: (userId: string) => `/admin/users/${userId}/chat-history`,
      AUDIT_LOGS: '/admin/audit-logs',
      PAYMENTS: '/admin/payments',
      SUBSCRIPTIONS: '/admin/subscriptions',
      SUBSCRIPTIONS_REVENUE: '/admin/subscriptions/revenue',
      FLAGGED_RESPONSES: '/admin/flagged-responses',
      DELETE_CONVERSATION_HISTORY: (userId: string) =>
        `/admin/users/${userId}/delete-conversation-history`,
    },
    PAYMENTS: {
      SUBSCRIPTION: '/payments/subscription',
      HISTORY: '/payments/history',
      CHECKOUT: '/payments/checkout',
    },
    TRACKING: {
      EVENT: '/tracking/event',
      ACTIVITY: '/tracking/activity',
      INTERACTION: '/tracking/interaction',
      MESSAGE: '/tracking/message',
      FEEDBACK: '/tracking/feedback',
    },
    FEATURE_FLAGS: {
      GET_ALL: '/feature-flags',
      ADMIN_BASE: '/admin/feature-flags',
      ADMIN_CREATE: '/admin/feature-flags',
      ADMIN_UPDATE: (flagName: string) => `/admin/feature-flags/${flagName}`,
      ADMIN_DELETE: (flagName: string) => `/admin/feature-flags/${flagName}`,
    },
  },
  METRICS: {
    ALL: '/metrics/all',
    EVENT: '/metrics/event',
    USER_ACTIVITY: '/metrics/user-activity',
    TIME_DISTRIBUTION: '/metrics/time-distribution',
    RETENTION: '/metrics/retention',
    TOPICS: '/metrics/topics',
    FEEDBACK: '/metrics/feedback',
    INTERACTIONS: '/metrics/interactions',
    DEVICE_USAGE: '/metrics/device-usage',
    BROWSER_DISTRIBUTION: '/metrics/browser-distribution',
  },
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
} as const;

export const APP_CONFIG = {
  DEFAULT_LANGUAGE: 'en',
  SUPPORTED_LANGUAGES: ['en', 'fr'] as const,
  SESSION_MAX_AGE: 30 * 24 * 60 * 60, // 30 days
  ROUTES: {
    HOME: '/',
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    CONVERSATIONS: '/conversations',
    ADMIN: '/admin',
    USERPROFILE: '/profile',
    FORMS: '/forms',
    OPEN_ROUTES: ['/auth/login', '/auth/register'] as string[],
    AUTH_ROUTES: ['/auth/login', '/auth/register', '/auth/error'] as string[],
  },
} as const;
